import React from 'react'

function HomeIcon() {
  return (
    <div>
        <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.56543 38.4869V12.6135L19.4996 2.64795L36.4338 12.6135V38.4869H2.56543Z" fill="#E2D8FF"/>
          <path d="M19.5001 3.24314L35.9212 12.9008V37.9737H3.07905V12.9008L19.5001 3.24314ZM19.5001 2.05261L2.05273 12.3158V39H36.9475V12.3158L19.5001 2.05261Z" fill="#460AF0"/>
          <path d="M19.4995 4.76205L0.512695 16.3697V12.2028L19.4995 0.605469L38.4864 12.2131V16.3799L19.4995 4.76205Z" fill="#E2D8FF"/>
          <path d="M19.5 1.20079L37.9737 12.4903V15.4563L20.0337 4.49526L19.5 4.16684L18.9663 4.49526L1.02632 15.4563V12.4903L19.5 1.20079ZM19.5 0L0 11.9155V17.2832L19.5 5.36763L39 17.2934V11.9258L19.5 0Z" fill="#460AF0"/>
          <path d="M7.69727 21.0394H17.9604V38.4868H7.69727V21.0394Z" fill="#EFEAFF"/>
          <path d="M17.4477 21.5527V37.9737H8.21089V21.5527H17.4477ZM18.474 20.5264H7.18457V39.0001H18.474V20.5264Z" fill="#460AF0"/>
          <path d="M15.9077 29.7632C15.6203 29.7632 15.3945 29.989 15.3945 30.2763C15.3945 30.5637 15.6203 30.7895 15.9077 30.7895C16.1951 30.7895 16.4208 30.5637 16.4208 30.2763C16.4208 29.989 16.1951 29.7632 15.9077 29.7632Z" fill="#460AF0"/>
          <path d="M23.0918 21.0396H31.3023V28.2238H23.0918V21.0396Z" fill="#EFEAFF"/>
          <path d="M30.7896 21.5527V27.7106H23.6054V21.5527H30.7896ZM31.8159 20.5264H22.5791V28.7369H31.8159V20.5264Z" fill="#460AF0"/>
        </svg>
    </div>
  )
}

export default HomeIcon